import EDISPresenter from "@adapters/features/EDIS/Presenters/EDISPresenter";
export default (function (useCases, actions) {
    return {
        edis: new EDISPresenter(useCases.edis, actions.edis),
    };
});
